import React from "react"
import Styles from "./smartTile.module.css"

export default function TileWrapper(props) {
  return <div className={`card ${Styles.tileWrapper}`}>{props.children}</div>
}
